import * as React from 'react'
import { Col, config, Container, Hidden, Row } from 'react-awesome-styled-grid'
import { colors, DipseaContentfulAssets } from '@components/shared'
import { contentfulLoader } from '../../services/images'
import styled from 'styled-components'
import { FadeInImage } from '@components/shared/FadeInImage'

export default function GiftContentUniverse (props: {
  cta: React.ReactNode
}): React.ReactNode {
  const renderMobileTopImage = (): React.ReactNode => {
    return (
      <>
        <Hidden xs={true} lg={true} xl={true}>
          <GiftUniverseSmallContainer>
            <FadeInImage
              loader={contentfulLoader}
              src={
                DipseaContentfulAssets[
                  'gifting-content-universe-tablet-top.png'
                ]
              }
              alt='Dipsea Content Universe'
              width={2385}
              height={561}
            />
          </GiftUniverseSmallContainer>
        </Hidden>

        <Hidden md={true} sm={true} lg={true} xl={true}>
          <GiftUniverseSmallContainer>
            <FadeInImage
              loader={contentfulLoader}
              src={
                DipseaContentfulAssets[
                  'gifting-content-universe-mobile-top.png'
                ]
              }
              alt='Dipsea Content Universe'
              width={1218}
              height={672}
            />
          </GiftUniverseSmallContainer>
        </Hidden>
      </>
    )
  }

  const renderMobileBottomImage = (): React.ReactNode => {
    return (
      <>
        <Hidden sm={true} md={true} lg={true} xl={true}>
          <GiftUniverseSmallBottomContainer>
            <FadeInImage
              loader={contentfulLoader}
              src={
                DipseaContentfulAssets[
                  'gifting-content-universe-mobile-bottom.png'
                ]
              }
              alt='Dipsea Content Universe'
              width={1545}
              height={891}
            />
          </GiftUniverseSmallBottomContainer>
        </Hidden>

        <Hidden xs={true} lg={true} xl={true}>
          <GiftUniverseSmallBottomContainer>
            <FadeInImage
              loader={contentfulLoader}
              src={
                DipseaContentfulAssets[
                  'gifting-content-universe-tablet-bottom.png'
                ]
              }
              alt='Dipsea Content Universe'
              width={2448}
              height={649}
            />
          </GiftUniverseSmallBottomContainer>
        </Hidden>
      </>
    )
  }

  const renderDesktopImage = (): React.ReactNode => {
    return (
      <Hidden sm={true} md={true} xs={true}>
        <GiftUniverseLargeContainer>
          <FadeInImage
            loader={contentfulLoader}
            src={DipseaContentfulAssets['gifting-content-universe-desktop.png']}
            alt='Dipsea Content Universe'
            width={2673}
            height={2349}
          />
        </GiftUniverseLargeContainer>
      </Hidden>
    )
  }

  return (
    <ContainerDiv>
      <Container>
        <Row>
          <Col md={8} lg={5} xl={5}>
            <SubHeaderContainer>
              {renderMobileTopImage()}

              <HeaderTextContainer>
                <SecondHeader>
                  Give the gift of unlimited smut
                </SecondHeader>

                <BodyText>
                  With a year of Dipsea, they’ll have access to 1000+ sexy stories and more, with new releases every week.
                </BodyText>
                {!!props.cta && <div>{props.cta}</div>}
              </HeaderTextContainer>

              {renderMobileBottomImage()}
            </SubHeaderContainer>
          </Col>

          {renderDesktopImage()}
        </Row>
      </Container>
    </ContainerDiv>
  )
}

const ContainerDiv = styled.div<any>`
  position: relative;
  overflow: hidden;
`
const SubHeaderContainer = styled.div<any>`
  margin-top: 70px;
  margin-bottom: 70px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1;
  ${(props: any): any => config(props).media.xs`
    height: auto;
    width: 100%;
  `}

  ${(props: any): any => config(props).media.lg`
    justify-content:center;
    height: 576px;
  `}

  ${(props: any): any => config(props).media.xl`
    height: 783px;
  `}
`

const HeaderTextContainer = styled.div<any>`
  margin: 0 0 40px;
  text-align: center;

  h2,
  p,
  div {
    text-align: center;
  }
  ${(props: any): any => config(props).media.lg`
    h2, p, div {
      text-align: left;
    }
    button {
      margin: 0 25px 16px 0 !important;
    }
  `}
`

const GiftUniverseLargeContainer = styled.div<any>`
  position: absolute;
  right: -7%;
  top: 15%;
  height: ${783 * 0.65}px;
  width: ${891 * 0.65}px;

  @media only screen and (min-width: 1170px) {
    position: absolute;
    right: -7%;
    top: 65px;
    height: ${783 * 0.75}px;
    width: ${891 * 0.75}px;
  }

  ${(props: any): any => config(props).media.xl`
    position: absolute;
    right: -8%;
    height: 783px;
    width: 891px;
  `}
`

const GiftUniverseSmallContainer = styled.div<any>`
  display: block;
  width: 406px;
  height: 224px;

  ${(props: any): any => config(props).media.sm`
    width: 795px;
    height: 187px;
  `}
`

const GiftUniverseSmallBottomContainer = styled.div<any>`
  display: block;
  width: 515px;
  height: 297px;

  ${(props: any): any => config(props).media.sm`
    width: 816px;
    height: 213px;
  `}
`

const BodyText = styled.p<any>`
  color: ${colors.sand};
  font-family: Good Sans Light;
  font-style: normal;
  font-weight: 300;
  letter-spacing: 0;
  margin: 0 0 36px;

  font-size: 16px;
  line-height: 24px;
  ${(props: any): any => config(props).media.lg`
    font-size: 18px;
    line-height: 27px;
  `}
`

const SecondHeader = styled.h2<any>`
  color: ${colors.sand};
  font-family: 'Queens Condensed Light';
  font-style: normal;
  font-weight: 300;
  line-height: 120%;
  margin: 30px 0px 16px 0px;

  font-size: 36px;
  ${(props: any): any => config(props).media.lg`
    margin: 30px 0px 20px 0px;
    font-size: 50px;
  `}
  ${(props: any): any => config(props).media.xl`
    font-size: 60px;
  `}
`
